// extracted by mini-css-extract-plugin
export var checkbox = "_94-0";
export var circle = "_94-3";
export var horizontalContainer = "_94-7";
export var sm = "_94-5";
export var switch0 = "_94-2";
export var switchDisabled = "_94-8";
export var switchEnabled = "_94-1";
export var textSwitchContainer = "_94-9";
export var textSwitchOption = "_94-a";
export var textSwitchOptionSelected = "_94-b";
export var verticalContainer = "_94-6";
export var xs = "_94-4";